module.exports = __webpack_public_path__ + "abb96ff0f47aab7b473029e17f7de52e.jpg";